import * as React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { message, Space, Switch } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import {
  BodyGroup,
  ConflictPop,
  NiTable,
  DiffDrawer,
  NiSpin,
  NiCard,
  NiButton,
  HelperPopover,
  sourceRender
} from '@component/index';
import { cloneDeep } from 'lodash';
import {
  Attribute,
  DiffStates,
  DataQuery,
  ValueSuggestionData,
  FrameType,
  valueSuggestionToServer,
  FrameItem,
  IntentInfo,
  ParameterType,
  ReferenceNode,
  ValueRecommendationSourceType
} from '@interface/index';
import { ValueSuggestionModal } from './modal';
import { localizedString } from '@locale/index';
import { AddButton } from '@component/buttons';
import { API, SourceType } from '@config/index';
import EmptyLine from '../empty-line/empty-line';

export interface ValueSuggestionState {
  cur?: ValueSuggestionData & { new?: boolean };
  visible: boolean;
  // frames: ({ value: string; label: string } & any)[];
  hover: number;
  loading: boolean;
}
export interface ValueSuggestionProps {
  onRef?: (ref: any) => void;
  frame: FrameItem;
  frameType: FrameType;
  forSlot?: Attribute;
  data: ValueSuggestionData[];
  dataQueries: DataQuery[];
  availableIntents: IntentInfo[];
  availableChannels: string[];
  // frames: any;
  selectedParameters: Attribute[];
  onChange?: (next: ValueSuggestionData[]) => void;
  didChange: (next: ValueSuggestionData[]) => void;
  cardDeleteClick?: () => void;
  disabled?: boolean;

  showSwitch?: boolean;
  switchChecked?: boolean;
  onSwitchChange?: (checked: boolean) => void;
}

export class ValueSuggestion extends React.Component<
  ValueSuggestionProps,
  ValueSuggestionState
> {
  public state: ValueSuggestionState = {
    visible: false,
    // frames: [],
    hover: -1,
    loading: false
  };

  componentDidMount(): void {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  detailComp = () => {
    const { forSlot, data } = this.props;

    return data && data.length && <NiTable
      showHeader={!forSlot}
      className="slot-suggestion-table"
      rowKey={(record: any) => `value-suggestion-${record.id}-${record.state}`}
      dataSource={this.getData()}
      pagination={{
        pageSize: 15,
        hideOnSinglePage: true
      }}
      style={forSlot ? { marginBottom: 8 } : {}}
      onRow={(record: ValueSuggestionData, index?: number) => {

        return {
          onClick: () => {
            if (record.state === DiffStates.DEL) {
              return;
            }

            this.setState({
              visible: true,
              cur: record
            });
          },
          onMouseEnter: () => {
            this.setState({
              hover: index || -1
            });
          },
          onMouseLeave: () => {
            this.setState({
              hover: -1
            });
          }
        };
      }}
      columns={this.getColumns()}
    /> || <EmptyLine text="Click to add a value recommendation" onClick={this.handleNewColumn} />;
  }

  render() {
    const state = this.state;

    const {
      dataQueries,
      data,
      frame,
      frameType,
      selectedParameters,
      disabled = false,
      availableIntents,
      availableChannels,
      forSlot,
      showSwitch,
      switchChecked,
      onSwitchChange
    } = this.props;

    return (
      <NiSpin spinning={state.loading}>
        {state.cur &&
          <ValueSuggestionModal
            disabled={disabled}
            availableIntents={availableIntents}
            availableChannels={availableChannels}
            frame={frame}
            frameType={frameType}
            forSlot={forSlot}
            visible={state.visible}
            data={state.cur as ValueSuggestionData}
            dataQueries={dataQueries}
            selectedParameters={selectedParameters}
            onChange={this.handleModalChange}
            onClose={this.handleModalClose}
          />
        }
        {
          !forSlot
            ? <BodyGroup
              foldable
              defaultFolded
              title={localizedString('value_suggestion')}
              titleExtra={<HelperPopover localizedKey="frame_hint_value_recommendations" />}
              extra={
                data && data.length && <AddButton
                  disabled={disabled || !!frame.originKey}
                  key="add-value-suggestion"
                  onClick={this.handleNewColumn}
                />
              }
            >
              {this.detailComp()}
            </BodyGroup>
            : (data && data.length && this.detailComp() || '')
          // <BodyGroup
          //   noPadding
          //   noTitleLine
          //   className={`slot-suggestion-card ${(!data || !data.length) && 'no-content'}`}
          //   title="Recommendation"
          //   titleExtra={<Space size={12}>
          //     <HelperPopover localizedKey="attribute_suggestion_popover" />
          //     {showSwitch && <Switch disabled={disabled || !!frame.originKey} checked={data && data.length > 0} onChange={(checked: boolean) => {
          //       if (checked) {
          //         this.handleNewColumn();
          //       } else {
          //         for (let i = 0; i < data.length; i = i + 1) {
          //           this.handleDeleteColumn(i);
          //         }
          //       }
          //     }} />}
          //   </Space>
          //   }
          //   extra={
          //     [
          //       // switchChecked &&
          //       // <AddButton
          //       //   disabled={
          //       //     disabled ||
          //       //     (forSlot.proto &&
          //       //       forSlot.proto.type === ParameterType.ENTITY &&
          //       //       data.length >= 1
          //       //     )
          //       //   }
          //       //   onClick={() => {
          //       //     this.handleNewColumn();
          //       //   }}
          //       // />

          //     ]}
          // >
          //   {this.detailComp()}
          // </BodyGroup>
        }
      </NiSpin>
    );
  }

  getData = () => {
    const state = this.state;
    const props = this.props;
    return props.data;
  };

  getColumns = () => {
    const state = this.state;
    const props = this.props;
    const columns: ColumnProps<any>[] = [];

    columns.push({
      title: localizedString('value_suggestion_use_data_query'),
      // width: '90%',
      key: 'source',
      render: (_: any, record: ValueSuggestionData, index: number) => {

        if (record.vrSourceType === ValueRecommendationSourceType.intent) {
          return record.sourceIntent && record.sourceIntent.intent && record.sourceIntent.intent.name;
        }

        if (props.forSlot) {
          return <span><label style={{ fontFamily: 'bold' }}>{localizedString('value_suggestion_use_data_query')}:</label> {record.source}</span>;
        }

        return record.source;
      }
    });
    if (!props.forSlot) {

      columns.push({
        width: 150,
        title: 'Source',
        dataIndex: 'inheritedFromCompositeName',
        render: (sourceName: string, record: ValueSuggestionData, index: number) => {
          return sourceRender(record, props.frameType);
        }
      });

      columns.push({
        title: '',
        width: 70,
        dataIndex: 'operation',
        className: 'hide',
        render: (operation: any, record: ValueSuggestionData, index: number) => (
          <div
            className="icon-area"
          >
            {!props.disabled &&
              !record.inheritedFromCompositeId &&
              !record.originKey ? (
              <DeleteOutlined
                className="delete-icon"
                onClick={this.handleDeleteColumn.bind(this, index)} />
            ) : (
              ''
            )}
          </div>
        )
      });
    }

    return columns;
  };

  getDataQueryName = (dataQueryId: string) => {
    const props = this.props;

    const curDataQuery = props.dataQueries.find(
      (dq: DataQuery) => dq.id === dataQueryId
    );

    return curDataQuery ? curDataQuery.name : localizedString('data_query_not_found');
  };

  handleNewColumn = () => {
    const { frame, forSlot } = this.props;
    this.setState({
      visible: true,
      cur: {
        id: '',
        ownerId: forSlot ? forSlot.id : frame.id,
        ownerType: forSlot ? ParameterType.ATTRIBUTE : frame.type,
        frameId: frame.id,
        inheritedFromCompositeId: '',
        inheritedFromCompositeName: '',
        isOverwrite: false,
        vrSourceType: ValueRecommendationSourceType.codeExpression,
        sourceType: SourceType.CODE_EXPRESSION,
        source: '',
        variable: [],
        parameters: [],
        channels: [],
        state: DiffStates.NORMAL,
        new: true,
        soft: false,
        singlePrompts: [],
        zeroPrompts: [],
        singleAffirmatives: [],
        singleNegatives: []
      }
    });
  };

  handleDeleteColumn = async (index: number, e?: React.MouseEvent<HTMLElement>) => {
    if (e) {
      e.stopPropagation();
    }

    const state = this.state;
    const props = this.props;
    const target = cloneDeep(props.data);

    const item = target[index];
    this.setState({ loading: true });
    await API.suggestion.delete({
      metaID: item.id || '',
      ownerID: item.ownerId,
      frameID: item.frameId
    }).catch((err: any) => {
      message.error(err.message);
      this.setState({ loading: false });
      throw new Error(err.message);
    });

    this.setState({ loading: false });

    target.splice(index, 1);
    props.didChange(target);
  };

  handleModalChange = async (next: ValueSuggestionData) => {
    const state = this.state;
    const props = this.props;

    let target = cloneDeep(props.data);
    const payload = valueSuggestionToServer(next);
    if ((next as any).new) {
      // if (props.forSlot && props.onChange) {
      //   props.onChange([
      //     ...props.data, next
      //   ]);
      //   return;
      // }

      this.setState({ loading: true });
      await API.suggestion.create(payload).catch((err: any) => {
        message.error(err.message);
        this.setState({ loading: false });
        throw new Error(err.message);
      });

      target.push({
        ...next,
        new: false
      } as any);
    } else {

      // if (props.forSlot && props.onChange) {

      //   let nextData = cloneDeep(props.data);
      //   nextData = nextData.map((item: ValueSuggestionData) =>
      //     item.id === next.id ? next : item);
      //   props.onChange(nextData);
      //   return;
      // }
      this.setState({ loading: true });

      if (next.inheritedFromCompositeId) {

        await API.suggestion.update(
          {
            metaID: next.id || '',
            ownerID: next.ownerId,
            frameID: next.frameId
          },
          payload,
          {
            metaID: next.id || '',
            frameID: props.frame.id,
            ownerID: props.forSlot ? props.forSlot.id : props.frame.id,
            ownerType: props.forSlot ? ParameterType.ATTRIBUTE : props.frameType
          }
        ).catch((e: Error) => {
          message.warning(localizedString('common_save_failed'));
          this.setState({ loading: false });
          throw e;
        });
      } else {
        await API.suggestion.update({
          metaID: next.id || '',
          ownerID: props.forSlot ? props.forSlot.id : props.frame.id,
          frameID: props.frame.id
        }, payload).catch((err: any) => {
          message.error(err.message);
          this.setState({ loading: false });
          throw new Error(err.message);
        });
      }

      target = target.map((vs: ValueSuggestionData) =>
        next.id === vs.id ? next : vs
      );
    }

    this.setState({ loading: false });
    props.didChange(target);
  };

  handleModalClose = () => {
    this.setState({
      visible: false
    });
  };
}
